import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
//import { Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
//import { useAuth } from './contexts/AuthContext';
import { MerchantProvider } from './contexts/MerchantContext';
import ErrorBoundary from './components/ErrorBoundary';
import LandingPage from './components/LandingPage';
import MerchantLayout from './components/MerchantLayout';
import ServiceList from './components/ServiceList';
import BookingForm from './components/BookingForm';
import BookingList from './components/BookingList';
import BookingConfirmation from './components/BookingConfirmation';
import Payment from './components/Payment';
import PaymentSuccess from './components/PaymentSuccess';
import PaymentError from './components/PaymentError';
import PaymentCancelled from './components/PaymentCancelled';
import LoginPage from './components/auth/LoginPage';
import LineCallback from './components/auth/LineCallback';
import LoginDebugPage from './components/auth/LoginDebugPage';
import LineDirectLogin from './components/auth/LineDirectLogin';
import UserProfile from './components/user/UserProfile';
import PromoPage from './components/PromoPage';
import BookingHistory from './components/user/BookingHistory';
import ApiDebug from './components/ApiDebug';
import TokenRefreshTest from './components/TokenRefreshTest';
import SsmsLoginPage from './ssms/pages/LoginPage';
import ManagerDashboard from './ssms/pages/ManagerDashboard';
import StaffDashboard from './ssms/pages/StaffDashboard';
//import DashboardEmployee from '../pages/employee/DashboardEmployee';
//import DashboardManager from '../pages/manager/DashboardManager';
import DevLoginButton from './components/DevLoginButton';
import SuperDebugger from './components/SuperDebugger';
import CouponList from 'components/user/CouponList';
import EventRegister from './components/events/EventRegister';
import EventResult from './components/events/EventResult';

/*
const ProtectedRoute = ({ children, allowedRoles }) => {
    // 假設 useAuth 提供了 isAuthenticated 和 userRole
    const { isAuthenticated, userRole } = useAuth(); 
    
    if (!isAuthenticated) {
        // 如果未登入，重定向到 SSMS 登入頁
        return <Navigate to="/ssms/login" replace />;
    }
    
    if (allowedRoles && !allowedRoles.includes(userRole)) {
        // 權限不足，重定向到登入頁或顯示錯誤信息
        return <Navigate to="/ssms/login" replace />; 
    }

    return children;
};
*/
function App() {
  return (
    <ErrorBoundary>
      <Router>
        <AuthProvider>
          <DevLoginButton />
          <SuperDebugger />
          <MerchantProvider>
            <Routes>
              {/* Root landing page */}
              <Route path="/" element={<LandingPage />} />
              

              {/* ==================================== */}
              {/* ✅ SSMS (員工/店長系統) 路由         */}
              {/* ==================================== */}
              
              {/* SSMS 公開登入頁面 */}
              <Route path="/ssms/login" element={<SsmsLoginPage />} />
              <Route path="/ssms/manager/dashboard" element={<ManagerDashboard />} />
              <Route path="/ssms/staff/dashboard" element={<StaffDashboard />} />

              {/* 員工儀表板 (需登入) */}
{/*               <Route 
                path="/employee/dashboard" 
                element={<ProtectedRoute allowedRoles={['EMPLOYEE', 'MANAGER']}><DashboardEmployee /></ProtectedRoute>} 
              /> */}
              
              {/* 員工報更意願管理 */}
{/*               <Route 
                path="/employee/shifts/my-requests" 
                element={<ProtectedRoute allowedRoles={['EMPLOYEE', 'MANAGER']}><MyShiftRequests /></ProtectedRoute>} 
              /> */}

              {/* 店長儀表板 / 排班表 (您現有的路由，已加上保護) */}
{/*               <Route 
                path="/manager/dashboard" 
                element={<ProtectedRoute allowedRoles={['MANAGER']}><RosterCalendar /></ProtectedRoute>} 
              /> */}
              
              {/* 店長報更意願總覽 */}
{/*               <Route 
                path="/manager/shifts/requests-overview" 
                element={<ProtectedRoute allowedRoles={['MANAGER']}><RequestsOverview /></ProtectedRoute>} 
              /> */}

              {/* 店長報更歷史追蹤 */}
{/*               <Route 
                path="/manager/shifts/requests-history" 
                element={<ProtectedRoute allowedRoles={['MANAGER']}><RequestsHistory /></ProtectedRoute>} 
              /> */}


              {/* Global routes (no merchant context) */}
              <Route path="/login" element={<LoginPage />} />
              <Route path="/debug-login" element={<LoginDebugPage />} />
              <Route path="/debug-api" element={<ApiDebug />} />
              <Route path="/auth/callback" element={<LineCallback />} />

              {/* LINE Direct Login (outside MerchantLayout to handle its own merchant loading) */}
              <Route path="/:merchantSlug/line-login" element={<LineDirectLogin />} />

              {/* 活動報名 + 綠界收款(唔使登入,唔需要 MerchantLayout) */}
              <Route path="/events/:slug" element={<EventRegister />} />
              <Route path="/events/:slug/result" element={<EventResult />} />

              {/* === 情況 A: Custom Domain (uat.kakatw.com/profile) === */}
              {/* 當沒有 slug 時，MerchantLayout 要自己識得從 Domain 判斷 slug */}
              <Route path="/" element={<MerchantLayout />}>
                  <Route path="profile" element={<UserProfile />} />
                  <Route path="promo" element={<PromoPage />} />
                  {/* 其他子路由... */}
              </Route>

              {/* Merchant-specific routes */}
              <Route path="/:merchantSlug" element={<MerchantLayout />}>
                <Route index element={<ServiceList />} />
                <Route path="coupons" element={<CouponList />} />
                <Route path="login" element={<LoginPage />} />
                <Route path="debug-login" element={<LoginDebugPage />} />
                <Route path="booking/:serviceId" element={<BookingForm />} />
                <Route path="bookings" element={<BookingList />} />
                <Route path="confirmation/:bookingId" element={<BookingConfirmation />} />
                <Route path="payment/:bookingId" element={<Payment />} />
                <Route path="payment/success/:paymentId" element={<PaymentSuccess />} />
                <Route path="payment/error/:paymentId" element={<PaymentError />} />
                <Route path="payment/cancelled/:paymentId" element={<PaymentCancelled />} />
                <Route path="profile" element={<UserProfile />} />
                <Route path="promo" element={<PromoPage />} />
                <Route path="booking-history" element={<BookingHistory />} />
                <Route path="debug-token" element={<TokenRefreshTest />} />
              </Route>
            </Routes>
          </MerchantProvider>
        </AuthProvider>
      </Router>
    </ErrorBoundary>
  );
}

export default App;